<template>
  <div class="fudao-container">
    <fudao-toolbar
      v-if="isFudaoConnected"
      class="fudao-toolbar"
      @endFudao="openEndFudaoDialog"
      @extendFudao="openExtendFudaoDialog"
      @inviteSession="openInviteSessionDialog"
      @endSession="openEndSessionDialog"
      @toggleChat="toggleChat"/>

    <div class="fudao-content">
      <!-- 視訊分享區塊(學生端白板畫面也顯示在這裡) -->
      <div
        id="fudaoVideo"
        v-show="sessionType === 'TeacherVideo' || (isFudaoStudent && sessionType === 'Whiteboard')"
        class="fudao-content__icelink-container">
      </div>

      <!-- 身分是老師，而且不是模擬輔導中的學生 -->
      <template v-if="isTeacher && isFudaoStudent !== true">
        <whiteboard
          id="fudaoWhiteboard"
          v-show="sessionType !== 'TeacherVideo'"
          class="flex-grow" />
        <chat v-show="isFudaoConnected" ref="chat" class="fudao-teacher-chat" />
      </template>
      <!-- 以學生的身分進行輔導 -->
      <template v-else>
        <chat
          v-show="!sessionType || sessionType === 'Audio'"
          ref="chat"
          class="flex-grow" />
      </template>
    </div>

    <fudao-timeup-dialog />

    <fudao-teacher-end-invite-dialog ref="endFudaoDialog" v-if="isTeacher" />
    <fudao-teacher-extend-invite-dialog ref="extendFudaoDialog" v-if="isTeacher" />
    <fudao-teacher-invite-session-dialog ref="inviteSessionDialog" v-if="isTeacher" />
    <fudao-teacher-end-session-dialog ref="endSessionDialog" v-if="isTeacher" />

    <fudao-student-end-invite-dialog v-if="isStudent" />
    <fudao-student-extend-invite-dialog v-if="isStudent" />
    <fudao-student-invite-session-dialog v-if="isStudent" />
    <fudao-student-end-session-dialog v-if="isStudent" />
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {FudaoEvent} from 'langyan';
import FudaoToolbar from './FudaoToolbar';
import FudaoTeacherEndInviteDialog from './FudaoTeacherEndInviteDialog';
import FudaoStudentEndInviteDialog from './FudaoStudentEndInviteDialog';
import FudaoTeacherExtendInviteDialog from './FudaoTeacherExtendInviteDialog';
import FudaoStudentExtendInviteDialog from './FudaoStudentExtendInviteDialog';

import FudaoTeacherInviteSessionDialog from './FudaoTeacherInviteSessionDialog';
import FudaoStudentInviteSessionDialog from './FudaoStudentInviteSessionDialog';
import FudaoTeacherEndSessionDialog from './FudaoTeacherEndSessionDialog';
import FudaoStudentEndSessionDialog from './FudaoStudentEndSessionDialog';

import FudaoTimeupDialog from './FudaoTimeupDialog';
import Chat from '../Chat/Chat';
import Whiteboard from '../Whiteboard/Whiteboard';

export default {
  components: {
    'fudao-toolbar': FudaoToolbar,

    'fudao-timeup-dialog': FudaoTimeupDialog,
    'fudao-teacher-end-invite-dialog': FudaoTeacherEndInviteDialog,
    'fudao-student-end-invite-dialog': FudaoStudentEndInviteDialog,
    'fudao-teacher-extend-invite-dialog': FudaoTeacherExtendInviteDialog,
    'fudao-student-extend-invite-dialog': FudaoStudentExtendInviteDialog,

    'fudao-teacher-invite-session-dialog': FudaoTeacherInviteSessionDialog,
    'fudao-student-invite-session-dialog': FudaoStudentInviteSessionDialog,
    'fudao-teacher-end-session-dialog': FudaoTeacherEndSessionDialog,
    'fudao-student-end-session-dialog': FudaoStudentEndSessionDialog,

    'chat': Chat,
    'whiteboard': Whiteboard
  },

  data() {
    return {
      isChatVisibe: true
    };
  },

  computed: {
    ...mapState('fudao', {
      sessionType: state => state.fudaoSession.SessionType
    }),

    ...mapGetters('fudao', {
      isFudaoConnected: 'isFudaoConnected',
      isFudaoStudent: 'isFudaoStudent'
    })
  },

  mounted() {
    this.$eventBus.$on(FudaoEvent.FudaoStarted, this.onFudaoStarted);
  },

  beforeDestroy() {
    this.$eventBus.$off(FudaoEvent.FudaoStarted, this.onFudaoStarted);
  },

  methods: {
    openChat() {
      this.isChatVisibe = true;
      let chatElm = this.$refs.chat.$el;
      Velocity(chatElm, 'stop');
      Velocity(chatElm, {translateX: '0%'}, {duration: 200, easing: 'easeInOutCubic'});
    },

    closeChat() {
      this.isChatVisibe = false;
      let chatElm = this.$refs.chat.$el;
      Velocity(chatElm, 'stop');
      Velocity(chatElm, {translateX: '-101%'}, {duration: 200, easing: 'easeInOutCubic', complete: () => {
        // this.$el.style.display = 'none';
      }});
    },

    toggleChat() {
      if (this.isChatVisibe) {
        this.closeChat();
      } else {
        this.openChat();
      }
    },

    onFudaoStarted() {
      this.$refs.chat.stickScrollbarToBottom();
    },

    openEndFudaoDialog() {
      this.$refs.endFudaoDialog.open();
    },

    openExtendFudaoDialog() {
      this.$refs.extendFudaoDialog.open();
    },

    openInviteSessionDialog(sessionType) {
      this.$refs.inviteSessionDialog.open(sessionType);
    },

    openEndSessionDialog(sessionType) {
      this.$refs.endSessionDialog.open(sessionType);
    }
  }
};
</script>

<style lang="stylus" scoped>

.fudao-container {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.fudao-toolbar {
}

.fudao-content {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.fudao-content__icelink-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  background-color: rgb(0,0,0);
}

.fudao-content__icelink-container >>> div {
  flex-grow: 1
}

.fudao-teacher-chat {
  position: absolute;
  max-height: 100%;
  width: 420px;
  top: 0;
  left: 0;
  box-shadow: $shadow-dark;
}
</style>
